export default function initOngletsNav() {
    const ongletsSwitchers = document.querySelectorAll('[data-onglet-switch]');
    const ongletsGroups = document.querySelectorAll('[data-onglet-group]');

    ongletsSwitchers.forEach((ongletSwitcher) => {
        ongletSwitcher.addEventListener('click', (e) => {
            e.preventDefault();

            const ongletSwitcherTarget = ongletSwitcher.getAttribute('href');

            const ongletTarget = document.querySelector(
                `[data-onglet-group="${ongletSwitcherTarget}"]`
            );

            // Add hash to current page url
            history.pushState(null, null, ongletSwitcherTarget);

            ongletsSwitchers.forEach((ongletSwitcher) => {
                ongletSwitcher.classList.remove('is-active');
            });
            ongletSwitcher.classList.add('is-active');

            if (!ongletTarget) {
                return;
            }

            ongletsGroups.forEach((ongletGroup) => {
                ongletGroup.classList.remove('is-active');
            });
            ongletTarget.classList.add('is-active');
        });
    });

    const currrentPageHash = window.location.hash;

    if (
        currrentPageHash &&
        document.querySelector(`[data-onglet-switch][href="${currrentPageHash}"]`)
    ) {
        document.querySelector(`[data-onglet-switch][href="${currrentPageHash}"]`).click();
    }
}
